module.exports = __webpack_public_path__ + "fonts/SofiaProUltraLight.a1810185.eot";